

















import { mapGetters } from 'vuex';

export default {
	name: 'MakeOfferDialog',

	setup() {
		return {};
	},

	props: {
		job_application_uuid: {
			type: String,
			required: false,
			default: null,
		},

		candidate: {
			type: Object,
			required: false,
		},
	},

	computed: {
		...mapGetters('jobs/single', {
			job: 'getSingleJob',
		}),

		...mapGetters('offerModule', {
			currentStep: 'getCurrentStep',
		}),
	},

	destroyed() {
		this.$store.dispatch('offerModule/setCurrentStep', 1);
	},

	mounted() {
		this.fetchJobDetails();
	},

	methods: {
		async fetchJobDetails() {
			await this.$store.dispatch('applications/getJobApplication', this.job_application_uuid);
		},
	},
};
